(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gnarly-character-signup"]) return;
  try {
    
document.addEventListener('DOMContentLoaded',()=>{const box=document.querySelector('[data-gcharacter]');if(!box)return;const key='gnarly-character-signup-dismissed';const last=Number(localStorage.getItem(key)||0);if(Date.now()-last<604800000)return;window.setTimeout(()=>{box.hidden=false},12000);box.querySelector('[data-gcharacter-close]')?.addEventListener('click',()=>{box.hidden=true;localStorage.setItem(key,String(Date.now()))})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gnarly-home"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-gnarly-home]').forEach((section)=>{const tabs=section.querySelectorAll('[data-gnarly-tab]');const panels=section.querySelectorAll('[data-gnarly-panel]');tabs.forEach((tab)=>tab.addEventListener('click',()=>{tabs.forEach((item)=>{item.classList.remove('is-active');item.setAttribute('aria-selected','false')});panels.forEach((panel)=>{panel.classList.remove('is-active');panel.hidden=true});tab.classList.add('is-active');tab.setAttribute('aria-selected','true');const panel=section.querySelector(`[data-gnarly-panel="${tab.dataset.gnarlyTab}"]`);if(panel){panel.hidden=false;panel.classList.add('is-active')}}))});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gnarly-product"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-gnarly-product]').forEach((section)=>{const quantity=section.querySelector('[data-gnarly-quantity]');const formQuantity=section.querySelector('[data-gnarly-form-quantity]');const total=section.querySelector('[data-gnarly-total]');const progress=section.querySelector('[data-gnarly-progress]');const shippingText=section.querySelector('[data-gnarly-shipping-text]');const cartCount=Math.max(0,Number.parseInt(section.dataset.cartCount,10)||0);const update=()=>{const count=Math.max(1,Number.parseInt(quantity.value,10)||1);const combinedCount=cartCount+count;quantity.value=count;formQuantity.value=count;if(total)total.textContent=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'}).format(Number(total.dataset.price)*count/100);progress.style.width=`${Math.min(100,combinedCount*10)}%`;shippingText.textContent=combinedCount>=10?'Free shipping unlocked':`${10-combinedCount} more ${10-combinedCount===1?'bag':'bags'} to free shipping`};section.querySelector('[data-gnarly-minus]')?.addEventListener('click',()=>{quantity.value=Math.max(1,Number(quantity.value)-1);update()});section.querySelector('[data-gnarly-plus]')?.addEventListener('click',()=>{quantity.value=Number(quantity.value)+1;update()});quantity?.addEventListener('change',update);section.querySelector('[data-gnarly-variant]')?.addEventListener('change',(event)=>{section.querySelector('[data-gnarly-form-variant]').value=event.target.value});section.querySelectorAll('[data-gnarly-thumb]').forEach((thumb)=>thumb.addEventListener('click',()=>{section.querySelector('[data-gnarly-main-image]').src=thumb.dataset.image;section.querySelectorAll('[data-gnarly-thumb]').forEach((item)=>item.classList.remove('is-active'));thumb.classList.add('is-active')}));update()});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
